import React, { useEffect, useState } from "react";
import { Notify } from "notiflix";
import Filter from "./Filter";
import Activity from "./Activity1";
import "./style.css";
import Activity2 from "./Activity2";
import FileUploader from "./Uploader/FileUploader";
import NoRegister from "./Uploader/NoRegister";
import BehalfSubmission from "./Uploader/BehalfSubmission";
import Table from "./Table";
import { duplicateFileValidation } from "../../../../../../../../../helper";
import { allowedExtensions } from "../../../../../../../../../helper/general";
import { IoClose } from "react-icons/io5";
import upload from './../../../../../../../../../Assets/Images/cloud.svg'

const arrayOfFile = [];

const ActivityDetail = ({ data, handleActivitySubmit, deleteSubmission, review_submission }) => {


  const [reload, setReload] = useState();
  const [fileArray, setFileArray] = useState([]);

  const handleFileChnage = e => {
    let filesArray = e.target.files;
    let fileDuplicate = "";
    for (let i = 0; i < filesArray.length; i++) {
      fileDuplicate = duplicateFileValidation(filesArray[i], arrayOfFile);
      if (fileDuplicate === undefined && arrayOfFile.length < 5) {
        arrayOfFile.push(filesArray[i]);
      }
    }
    setFileArray(arrayOfFile);
    setReload(Math.random());
  };

  const onFileDelete = (arrayIndex) => {
    const newFiles = [...fileArray];
    newFiles.splice(arrayIndex, 1);
    setFileArray(newFiles);
    arrayOfFile.length = 0;
    for (let i = 0; i < newFiles.length; i++) {
      arrayOfFile.push(newFiles[i]);
    }
  };

  const handleSubmit = () => {

    // file validation
    const filenew = fileArray.map((index, filenew) => index.name.replace("C:\\fakepath\\", " "));
    //File Size validtion
    const size = fileArray.map((index, file) => parseInt(index.size.toString().slice(0, -3)));
    const fileSizeArray = size.reduce((a, v) => (a = a + v), 0);
    const fileSize = fileSizeArray / 1024;
    // file extension array
    var extension = fileArray.map((index, file) => index.name.substr(index.name.lastIndexOf(".") + 1).toLowerCase());
    var extensionResult = extension.every(function (val) { return allowedExtensions.indexOf(val) >= 0; });
    if (filenew === "" || filenew === undefined) {
      Notify.warning("Please upload file");
    } else if (filenew !== "" && extensionResult === false) {
      Notify.warning("Invalid file type");
    } else if (filenew !== "" && fileSize > 100) {
      Notify.warning("File size should be <= 100 MB");
    }
    if ((fileSize < 100 || fileSize === 100) && filenew !== "" && filenew !== undefined && extensionResult === true) {
      const zip = require("jszip")();
      let files = fileArray;
      for (let file = 0; file < fileArray.length; file++) {
        // Zip file with the file name.
        zip.file(files[file].name, files[file]);
      }
      zip.generateAsync({ type: "blob" }).then((content) => {
        Notify.warning("Please wait files are getting uploaded");
        const formData = new FormData();
        formData.append("file", content);
        handleActivitySubmit(formData, () => {
          setFileArray([]);
          arrayOfFile.splice(0, arrayOfFile.length);
        })
      })
    }
  }

  return (
    <div className="text-center">
      {data?.submission?.map((item, key) => <Activity data={item} id={key} deleteSubmission={deleteSubmission} review_submission={review_submission} />)}
      {data?.is_submission_allowed?.status &&
        <div className="mt-3">
          <div className="uploader contact-uploader">
            <input type="file" onChange={handleFileChnage} className="form-control rounded-0" id="inputGroupFile01" multiple />
            <div className="wrapp">
              <div className="uploader-content">
                <div className="upload-icon">
                  <img src={upload} />
                </div>
                <a className={`btn mt-4 bg-blue`}>Browse File</a>
              </div>
            </div>
          </div>
          <div className="cstm-file-list">
            <ul>
              {fileArray.map((content, index) => <li key={index} className="mb-1">{content.name}<span><IoClose name="close" onClick={() => onFileDelete(index)} /></span></li>)}
            </ul>
          </div>
          <button className="btn mt-4 uploder-btn" onClick={handleSubmit} disabled={!fileArray?.length}>Make submission on behalf of the student</button>
        </div>
      }
    </div>
  );
};

export default ActivityDetail;
